import { BASE } from "./shop";

async function handle(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "No pudimos completar la solicitud.");
  return data;
}

/** Turns the product-form state into multipart/form-data (needed for file uploads). */
function toFormData(product) {
  const fd = new FormData();
  const scalarFields = ["title", "brand", "sku", "category", "description", "price", "discountPrice", "stock", "condition", "isFeatured", "isActive"];

  scalarFields.forEach((key) => {
    if (product[key] !== undefined && product[key] !== null) fd.append(key, product[key]);
  });

  fd.append("specs", JSON.stringify(product.specs || {}));
  fd.append("extraSpecs", JSON.stringify(product.extraSpecs || []));
  fd.append("tags", JSON.stringify(product.tags || []));
  fd.append("existingImages", JSON.stringify(product.existingImages || []));

  (product.newImages || []).forEach((file) => fd.append("images", file));

  return fd;
}

export async function fetchAdminProducts({ page = 1, limit = 30, q = "" } = {}, token) {
  const query = new URLSearchParams({ page, limit, q });
  const res = await fetch(`${BASE}/api/products/admin/all?${query}`, { headers: { token } });
  return handle(res);
}

export async function fetchAdminProduct(id, token) {
  const res = await fetch(`${BASE}/api/products/admin/${id}`, { headers: { token } });
  return handle(res);
}

export async function createProduct(product, token) {
  const res = await fetch(`${BASE}/api/products`, {
    method: "POST",
    headers: { token },
    body: toFormData(product),
  });
  return handle(res);
}

export async function updateProduct(id, product, token) {
  const res = await fetch(`${BASE}/api/products/${id}`, {
    method: "PUT",
    headers: { token },
    body: toFormData(product),
  });
  return handle(res);
}

export async function deleteProduct(id, token) {
  const res = await fetch(`${BASE}/api/products/${id}`, { method: "DELETE", headers: { token } });
  return handle(res);
}

export async function fetchAdminOrders({ page = 1, limit = 30, status = "" } = {}, token) {
  const query = new URLSearchParams({ page, limit, status });
  const res = await fetch(`${BASE}/api/orders/admin/all?${query}`, { headers: { token } });
  return handle(res);
}

export async function updateOrderStatus(id, status, token) {
  const res = await fetch(`${BASE}/api/orders/admin/${id}/status`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", token },
    body: JSON.stringify({ status }),
  });
  return handle(res);
}
